import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Appshell/Appshell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/vercel/path0/contexts/UserContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/carousel/styles.layer.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/charts/styles.layer.css");
;
import(/* webpackMode: "eager", webpackExports: ["ColorSchemeScript"] */ "/vercel/path0/node_modules/@mantine/core/esm/core/MantineProvider/ColorSchemeScript/ColorSchemeScript.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["MantineProvider"] */ "/vercel/path0/node_modules/@mantine/core/esm/core/MantineProvider/MantineProvider.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/core/styles.layer.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/dates/styles.layer.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/mantine-react-table/styles.css");
